export const informationConstants = {
	FETCH_FUND_INFO_START: 'FETCH_FUND_INFO_START',
	FETCH_FUND_INFO_SUCCESS: 'FETCH_FUND_INFO_SUCCESS',
	FETCH_FUND_INFO_FAILURE: 'FETCH_FUND_INFO_FAILURE',

	CLEAR_FUND_INFO: 'CLEAR_FUND_INFO',

	FETCH_PORTFOLIO_INFO_START: 'FETCH_PORTFOLIO_INFO_START',
	FETCH_PORTFOLIO_INFO_SUCCESS: 'FETCH_PORTFOLIO_INFO_SUCCESS',
	FETCH_PORTFOLIO_INFO_FAILURE: 'FETCH_PORTFOLIO_INFO_FAILURE',

	UPDATE_FUND_ID: 'UPDATE_FUND_ID',
	UPDATE_RECENT_TAB: 'UPDATE_RECENT_TAB',

	FETCH_TRADING_INFO_START: 'FETCH_TRADING_INFO_START',
	FETCH_TRADING_INFO_SUCCESS: 'FETCH_TRADING_INFO_SUCCESS',
	FETCH_TRADING_INFO_FAILURE: 'FETCH_TRADING_INFO_FAILURE',

	FETCH_FUND_AVERAGE_RATING_START: 'FETCH_FUND_AVERAGE_RATING_START',
	FETCH_FUND_AVERAGE_RATING_SUCCESS: 'FETCH_FUND_AVERAGE_RATING_SUCCESS',
	FETCH_FUND_AVERAGE_RATING_FAILURE: 'FETCH_FUND_AVERAGE_RATING_FAILURE',

	VOTE_FUND_AVERAGE_RATING: 'VOTE_FUND_AVERAGE_RATING',

	FETCH_CALENDAR_FUND_START: 'FETCH_CALENDAR_FUND_START',
	FETCH_CALENDAR_FUND_SUCCESS: 'FETCH_CALENDAR_FUND_SUCCESS',
	FETCH_CALENDAR_FUND_FAILURE: 'FETCH_CALENDAR_FUND_FAILURE',

	// Port Info
	FETCH_FUND_PORT_INFO_START: 'FETCH_FUND_PORT_INFO_START',
	FETCH_FUND_PORT_INFO_SUCCESS: 'FETCH_FUND_PORT_INFO_SUCCESS',
	FETCH_FUND_PORT_INFO_FAILURE: 'FETCH_FUND_PORT_INFO_FAILURE',

	FETCH_FUND_PORT_CHART_BY_CHART_TYPE_START: 'FETCH_FUND_PORT_CHART_BY_CHART_TYPE_START',
	FETCH_FUND_PORT_CHART_BY_CHART_TYPE_SUCCESS: 'FETCH_FUND_PORT_CHART_BY_CHART_TYPE_SUCCESS',
	FETCH_FUND_PORT_CHART_BY_CHART_TYPE_FAILURE: 'FETCH_FUND_PORT_CHART_BY_CHART_TYPE_FAILURE',

	// STATISTIC
	FETCH_WEEKLY_FUND_RANKING_START: 'FETCH_WEEKLY_FUND_RANKING_START',
	FETCH_WEEKLY_FUND_RANKING_SUCCESS: 'FETCH_WEEKLY_FUND_RANKING_SUCCESS',
	FETCH_WEEKLY_FUND_RANKING_FAILURE: 'FETCH_WEEKLY_FUND_RANKING_FAILURE',


	FETCH_DRAWDOWN_BY_DATE_START: 'FETCH_DRAWDOWN_BY_DATE_START',
	FETCH_DRAWDOWN_BY_DATE_SUCCESS: 'FETCH_DRAWDOWN_BY_DATE_SUCCESS',
	FETCH_DRAWDOWN_BY_DATE_FAILURE: 'FETCH_DRAWDOWN_BY_DATE_FAILURE',

	FETCH_MAXIMUM_DRAWDOWN_START: 'FETCH_MAXIMUM_DRAWDOWN_START',
	FETCH_MAXIMUM_DRAWDOWN_SUCCESS: 'FETCH_MAXIMUM_DRAWDOWN_SUCCESS',
	FETCH_MAXIMUM_DRAWDOWN_FAILURE: 'FETCH_MAXIMUM_DRAWDOWN_FAILURE',

	FETCH_DRAWDOWN_NAV_GRAPH_START: 'FETCH_DRAWDOWN_NAV_GRAPH_START',
	FETCH_DRAWDOWN_NAV_GRAPH_SUCCESS: 'FETCH_DRAWDOWN_NAV_GRAPH_SUCCESS',
	FETCH_DRAWDOWN_NAV_GRAPH_FAILURE: 'FETCH_DRAWDOWN_NAV_GRAPH_FAILURE',

	CHANGE_DRAWDOWN_STATISTIC_FILTERS: 'CHANGE_DRAWDOWN_STATISTIC_FILTERS',
	CHANGE_NAV_GRAPH_DATE: 'CHANGE_NAV_GRAPH_DATE',
	CHANGE_SORTED_DRAWDOWN: 'CHANGE_SORTED_DRAWDOWN',

	FETCH_MONTHLY_RETURN_START: 'FETCH_MONTHLY_RETURN_START',
	FETCH_MONTHLY_RETURN_SUCCESS: 'FETCH_MONTHLY_RETURN_SUCCESS',
	FETCH_MONTHLY_RETURN_FAILURE: 'FETCH_MONTHLY_RETURN_FAILURE',

	FETCH_PRICE_RANGE_START: 'FETCH_PRICE_RANGE_START',
	FETCH_PRICE_RANGE_SUCCESS: 'FETCH_PRICE_RANGE_SUCCESS',
	FETCH_PRICE_RANGE_FAILURE: 'FETCH_PRICE_RANGE_FAILURE',

	FETCH_VOLATILITIES_START: 'FETCH_VOLATILITIES_START',
	FETCH_VOLATILITIES_SUCCESS: 'FETCH_VOLATILITIES_SUCCESS',
	FETCH_VOLATILITIES_FAILURE: 'FETCH_VOLATILITIES_FAILURE',

	FETCH_RETURN_EXPENSE_RATIO_START: 'FETCH_RETURN_EXPENSE_RATIO_START',
	FETCH_RETURN_EXPENSE_RATIO_SUCCESS: 'FETCH_RETURN_EXPENSE_RATIO_SUCCESS',
	FETCH_RETURN_EXPENSE_RATIO_FAILURE: 'FETCH_RETURN_EXPENSE_RATIO_FAILURE',

	FETCH_MONTHLY_PROFIT_START: 'FETCH_MONTHLY_PROFIT_START',
	FETCH_MONTHLY_PROFIT_SUCCESS: 'FETCH_MONTHLY_PROFIT_SUCCESS',
	FETCH_MONTHLY_PROFIT_FAILURE: 'FETCH_MONTHLY_PROFIT_FAILURE',

	FETCH_RETURN_HISTORY_START: 'FETCH_RETURN_HISTORY_START',
	FETCH_RETURN_HISTORY_SUCCESS: 'FETCH_RETURN_HISTORY_SUCCESS',
	FETCH_RETURN_HISTORY_FAILURE: 'FETCH_RETURN_HISTORY_FAILURE',

	// HISTORICAL
	FETCH_RETURN_HISTORY_START: 'FETCH_RETURN_HISTORY_START',
	FETCH_RETURN_HISTORY_SUCCESS: 'FETCH_RETURN_HISTORY_SUCCESS',
	FETCH_RETURN_HISTORY_FAILURE: 'FETCH_RETURN_HISTORY_FAILURE',

	FETCH_RANKING_HISTORY_START: 'FETCH_RANKING_HISTORY_START',
	FETCH_RANKING_HISTORY_SUCCESS: 'FETCH_RANKING_HISTORY_SUCCESS',
	FETCH_RANKING_HISTORY_FAILURE: 'FETCH_RANKING_HISTORY_FAILURE',

	FETCH_PRICE_RANGE_START: 'FETCH_PRICE_RANGE_START',
	FETCH_PRICE_RANGE_SUCCESS: 'FETCH_PRICE_RANGE_SUCCESS',
	FETCH_PRICE_RANGE_FAILURE: 'FETCH_PRICE_RANGE_FAILURE',

	FETCH_RETURN_MONTHLY_START: 'FETCH_RETURN_MONTHLY_START',
	FETCH_RETURN_MONTHLY_SUCCESS: 'FETCH_RETURN_MONTHLY_SUCCESS',
	FETCH_RETURN_MONTHLY_FAILURE: 'FETCH_RETURN_MONTHLY_FAILURE',

	FETCH_HISTORICAL_NAV_START: 'FETCH_HISTORICAL_NAV_START',
	FETCH_HISTORICAL_NAV_SUCCESS: 'FETCH_HISTORICAL_NAV_SUCCESS',
	FETCH_HISTORICAL_NAV_FAILURE: 'FETCH_HISTORICAL_NAV_FAILURE',
	FETCH_HISTORICAL_NAV_CHANGE_PAGE: 'FETCH_HISTORICAL_NAV_CHANGE_PAGE',

	FETCH_HISTORICAL_NAV_GRAPH_START: 'FETCH_HISTORICAL_NAV_GRAPH_START',
	FETCH_HISTORICAL_NAV_GRAPH_SUCCESS: 'FETCH_HISTORICAL_NAV_GRAPH_SUCCESS',
	FETCH_HISTORICAL_NAV_GRAPH_FAILURE: 'FETCH_HISTORICAL_NAV_GRAPH_FAILURE',

	// Dividend
	FETCH_DIVIDEND_START: 'FETCH_DIVIDEND_START',
	FETCH_DIVIDEND_SUCCESS: 'FETCH_DIVIDEND_SUCCESS',
	FETCH_DIVIDEND_FAILURE: 'FETCH_DIVIDEND_FAILURE',
	FETCH_DIVIDEND_CHANGE_PAGE: 'FETCH_DIVIDEND_CHANGE_PAGE',

	FETCH_DIVIDEND_GROUP_BY_YEAR_START: 'FETCH_DIVIDEND_GROUP_BY_YEAR_START',
	FETCH_DIVIDEND_GROUP_BY_YEAR_SUCCESS: 'FETCH_DIVIDEND_GROUP_BY_YEAR_SUCCESS',
	FETCH_DIVIDEND_GROUP_BY_YEAR_FAILURE: 'FETCH_DIVIDEND_GROUP_BY_YEAR_FAILURE',

	FETCH_DIVIDEND_DESCRIPTION_START: 'FETCH_DIVIDEND_DESCRIPTION_START',
	FETCH_DIVIDEND_DESCRIPTION_SUCCESS: 'FETCH_DIVIDEND_DESCRIPTION_SUCCESS',
	FETCH_DIVIDEND_DESCRIPTION_FAILURE: 'FETCH_DIVIDEND_DESCRIPTION_FAILURE',

	FETCH_CHANGE_ACTIVE_BTN: 'FETCH_CHANGE_ACTIVE_BTN',
	// INSERT_SCROLL_POSITION: 'INSERT_SCROLL_POSITION'
};
